import axiosClient from "apis/axios-client";

export interface AirlineNotesResponse {
    id: number;
    airlineId: number;
    airlineName: string;
    notes: Record<string, string | null | undefined> | null;
    createdAt?: string;
}

export const getAirlineNotesById = async (
    airlineId: number
): Promise<AirlineNotesResponse> => {
    const response = await axiosClient.get<AirlineNotesResponse>(
        "/User/GetAirlineNotes",
        {
            params: { airlineId },
        }
    );

    return response as unknown as AirlineNotesResponse;
};

